import NotFoundPage from '../pages/404';
import { LoginPage } from '../pages/auth/login';
import { RecoverPage } from '../pages/auth/recover';
import { DossiePublicoPage } from '../pages/dossiePublico';
import { EstatutoPublicoPage } from '../pages/estatutoPublico';
import { SecaoClienteLoginPage } from '../pages/secaoCliente/login';
import SecaoClienteDashboard from '../pages/secaoCliente/dashboard';
import SecaoClienteDossie from '../pages/secaoCliente/dossie';
import SecaoClienteDossieEmpresa from '../pages/secaoCliente/dossie/DossieEmpresa';
import SecaoClienteDocumentos from '../pages/secaoCliente/documentos';
import DocumentosEmpresa from '../pages/secaoCliente/documentos/DocumentosEmpresa';
import SecaoClienteGuias from '../pages/secaoCliente/guias';
import GuiasEmpresa from '../pages/secaoCliente/guias/GuiasEmpresa';
import SecaoClientePerfil from '../pages/secaoCliente/perfil';
import SecaoClienteEventos from '../pages/secaoCliente/eventos';
import EventoClienteDetalhe from '../pages/secaoCliente/eventos/EventoClienteDetalhe';
import KanbanClienteBoard from '../pages/secaoCliente/eventos/KanbanClienteBoard';
import SecaoClienteKanbanList from '../pages/secaoCliente/kanban';

export const OpenRoutes = [
  {
    name: 'Dossiê Público',
    path: '/dossie/:hashedLink',
    component: DossiePublicoPage,
  },
  {
    name: 'Estatuto - Preenchimento Público',
    path: '/estatuto/preencher/:token',
    component: EstatutoPublicoPage,
  },
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
  },
  {
    name: 'Recuperar Senha',
    path: '/recover',
    component: RecoverPage,
  },
  {
    name: 'Seção Cliente - Login',
    path: '/secao-cliente/login',
    component: SecaoClienteLoginPage,
  },
  {
    name: 'Seção Cliente - Dashboard',
    path: '/secao-cliente/dashboard',
    component: SecaoClienteDashboard,
  },
  {
    name: 'Seção Cliente - Dossiê',
    path: '/secao-cliente/dossie',
    component: SecaoClienteDossie,
  },
  {
    name: 'Seção Cliente - Dossiê Empresa',
    path: '/secao-cliente/dossie/:empresaId',
    component: SecaoClienteDossieEmpresa,
  },
  {
    name: 'Seção Cliente - Documentos',
    path: '/secao-cliente/documentos',
    component: SecaoClienteDocumentos,
  },
  {
    name: 'Seção Cliente - Documentos Empresa',
    path: '/secao-cliente/documentos/:empresaId',
    component: DocumentosEmpresa,
  },
  {
    name: 'Seção Cliente - Guias',
    path: '/secao-cliente/guias',
    component: SecaoClienteGuias,
  },
  {
    name: 'Seção Cliente - Guias Empresa',
    path: '/secao-cliente/guias/:empresaId',
    component: GuiasEmpresa,
  },
  {
    name: 'Seção Cliente - Perfil',
    path: '/secao-cliente/perfil',
    component: SecaoClientePerfil,
  },
  {
    name: 'Seção Cliente - Eventos',
    path: '/secao-cliente/eventos',
    component: SecaoClienteEventos,
  },
  {
    name: 'Seção Cliente - Kanban',
    path: '/secao-cliente/kanban',
    component: SecaoClienteKanbanList,
  },
  {
    name: 'Seção Cliente - Kanban Evento',
    path: '/secao-cliente/eventos/:eventoId/kanban',
    component: KanbanClienteBoard,
  },
  {
    name: 'Seção Cliente - Evento Detalhe',
    path: '/secao-cliente/eventos/:eventoId',
    component: EventoClienteDetalhe,
  },
];

export { NotFoundPage };
